/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import { withRouter } from 'react-router-dom';
import { getNewUiUrl } from '../../utils/urlHelper';

class AdminFooter extends React.Component {
  render() {
    return (
      <>
        <Container fluid>
          <footer className="footer pt-0" style={{backgroundColor:"white"}}>
            <Row className="align-items-center justify-content-lg-between">
              <Col lg="6">
                <div className="copyright text-center text-lg-left text-muted">
                  © {new Date().getFullYear()}{" "}
                  <a
                      className="font-weight-bold ml-1"
                      href="https://sekim-international.com/"
                      target="_blank"
                  >
                    Sekim International
                  </a>
                </div>
              </Col>
              <Col lg="6">
                <Nav className="nav-footer justify-content-center justify-content-lg-end">
                  <NavItem>
                    <NavLink
                        href="https://xaregrowth.com"
                      target="_blank"
                    >
                      XareGrowth
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href=""
                      target="_blank"
                      onClick={(event) => {
                        event.preventDefault();
                        window.location.href = getNewUiUrl() + "/about-us";
                      }}
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </footer>
        </Container>
      </>
    );
  }
}

export default withRouter(AdminFooter);
